/**
 * TOPに戻るボタンの挙動管理
 */
export default function scrollTopButton() {
  (function ($) {
    // 変数にクラスを入れる
    var btn = $('#scroll-top');

    //スクロールしてページトップから100に達したらボタンを表示
    $(window).on('load scroll', function(){
      if($(this).scrollTop() > 100) {
        btn.addClass('js-is-active');
      }else{
        btn.removeClass('js-is-active');
      }
    });
  })(jQuery);
}
